import { useContext } from 'react'
import { throwPlatformError, UIErrorCode } from '../../errors'
import { PageStateContext } from '../context'

export const usePageStateContext = () => {
  const context = useContext(PageStateContext)
  if (!context) {
    throwPlatformError(
      'Unable to find PageStateContext. Has PageStateProvider been initialized?',
      UIErrorCode.CORE_CONTEXT_NOT_FOUND,
    )
  }
  return context
}
